module.exports = __webpack_public_path__ + "assets/img/step5.c629747b.jpg";